var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.586914 0.586914C0.879795 0.294033 1.35456 0.294057 1.64746 0.586914L10.5859 9.5253C11.3669 10.3063 12.6332 10.3064 13.4142 9.52537L22.3525 0.587891C22.6454 0.294997 23.1202 0.294997 23.4131 0.587891C23.7057 0.88081 23.7059 1.35565 23.4131 1.64844L14.4749 10.5858C13.6938 11.3668 13.6938 12.6332 14.4748 13.4143L23.4121 22.3516C23.705 22.6445 23.705 23.1192 23.4121 23.4121C23.1192 23.705 22.6445 23.705 22.3516 23.4121L13.4142 14.4748C12.6332 13.6937 11.3668 13.6937 10.5858 14.4748L1.64746 23.4131C1.35455 23.7057 0.879727 23.7059 0.586914 23.4131C0.294262 23.1203 0.294314 22.6454 0.586914 22.3525L9.52524 13.4142C10.3063 12.6332 10.3063 11.3668 9.52524 10.5858L0.586914 1.64746C0.294057 1.35456 0.294033 0.879795 0.586914 0.586914Z",
    fill: "#6C6859"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/CrossIcon.d20b88796e671fd5a51def1df0fdd4d4.svg";
export { ForwardRef as ReactComponent };